import CryptoJS from "crypto-js";

function DecryptData(dncToken){
  let value = localStorage.getItem(dncToken)
  if(value){
    const accessKey = process.env.REACT_APP_ACCESS_KEY;
    if (accessKey) {
      try {
        let data = CryptoJS.AES.decrypt(value, accessKey)
        let final = data.toString(CryptoJS.enc.Utf8);
        return JSON.parse(final);
      } catch (e) {
        console.warn('Decryption failed, attempting to parse stored value as JSON.', e);
        try { return JSON.parse(value); } catch { return value; }
      }
    } else {
      try { return JSON.parse(value); } catch { return value; }
    }
  }else{
    return "";
  }
}

export default DecryptData;